/**
 * Step 20E1: Disponibilidade para Entrevista Online
 * Coleta disponibilidade de horário para entrevista
 */

import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext } from '../context';

export const Step20E1_Entrevista: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.disponivelEntrevistaOnline) newErrors.disponivelEntrevistaOnline = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ disponivelEntrevistaOnline: data.disponivelEntrevistaOnline });
  };

  const handleFieldChange = (value: string) => {
    updateField('disponivelEntrevistaOnline', value);
    if (errors.disponivelEntrevistaOnline) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors.disponivelEntrevistaOnline;
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">Você tem disponibilidade para uma entrevista online? Se sim, qual o melhor horário para você?</p>
        <p className="text-muted-foreground text-sm mb-4">
          A entrevista tem duração média de 30 minutos.
        </p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Manhã (8h às 12h)', value: 'manha' },
            { label: 'Tarde (13h às 18h)', value: 'tarde' },
            { label: 'Noite (18h às 20h)', value: 'noite' },
            { label: 'Não tenho disponibilidade', value: 'sem-disponibilidade' },
          ]}
          selected={data.disponivelEntrevistaOnline || ''}
          onSelect={handleFieldChange}
        />
        {errors.disponivelEntrevistaOnline && (
          <p className="text-red-600 text-sm mt-2">{errors.disponivelEntrevistaOnline}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step20E1_Entrevista;
